import { useContent } from "@/lib/content";

const stopNav = (e) => { e.preventDefault(); e.stopPropagation(); };

export const EditableText = ({ k, as: Tag = "span", className = "", children, multiline = false, ...rest }) => {
  const { editMode, text, stage } = useContent();
  const fallback = typeof children === "string" ? children : "";
  const value = text(k, fallback);
  const pre = multiline ? " whitespace-pre-line" : "";

  if (!editMode) {
    return <Tag className={className + pre} {...rest}>{value || children}</Tag>;
  }

  const commit = (e) => {
    const next = e.currentTarget.innerText.replace(/\u00a0/g, " ").trim();
    if (next !== value) stage(k, { content: next });
  };

  return (
    <Tag
      {...rest}
      className={`${className}${pre} live-editable`}
      contentEditable
      suppressContentEditableWarning
      spellCheck={false}
      data-live-key={k}
      title={`Editing: ${k}`}
      onClick={stopNav}
      onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter" && !multiline) { e.preventDefault(); e.currentTarget.blur(); } }}
    >
      {value}
    </Tag>
  );
};
